<template>
  <div class="row sp">
    <div class="col-12 g">
      <div class="card card-body mb-0">
        <div class="d-flex flex-wrap justify-content-between align-items-start sp-head">
          <div>
            <h4 class="mb-25"><i class="fa fa-life-ring"></i> الدعم الفني السريع</h4>
            <p class="text-muted mb-0">تذاكر المدارس العاجلة من تطبيق المدرسة، وهي نفس التذاكر التي يعمل عليها فريق الدعم في تطبيق «دعم فني VIP».</p>
          </div>
          <div class="btn-group" role="tablist" aria-label="الأقسام">
            <button class="btn btn-sm" :class="tab == 'tickets' ? 'btn-primary' : 'btn-outline-primary'" @click="tab = 'tickets'">التذاكر</button>
            <button class="btn btn-sm" :class="tab == 'vip' ? 'btn-primary' : 'btn-outline-primary'" @click="openVip()">تطبيق الدعم VIP</button>
          </div>
        </div>
        <div class="stats">
          <div class="stat urgent"><span>عاجلة مفتوحة</span><b class="num">{{ counts.open_urgent }}</b></div>
          <div class="stat"><span>كل المفتوحة</span><b class="num">{{ counts.open }}</b></div>
          <div class="stat"><span>أُغلقت اليوم</span><b class="num">{{ counts.closed_today }}</b></div>
          <div class="stat"><span>متوسط أول رد (7 أيام)</span><b class="num">{{ avgText }}</b></div>
        </div>
      </div>
    </div>

    <!-- tickets -->
    <template v-if="tab == 'tickets'">
      <div class="col-12 col-lg-5 g">
        <div class="card mb-0 list-card">
          <div class="card-body pb-50">
            <div class="d-flex flex-wrap align-items-center filters">
              <div class="btn-group" role="group" aria-label="الحالة">
                <button v-for="s in statuses" :key="s.key" class="btn btn-sm" :class="status == s.key ? 'btn-primary' : 'btn-outline-primary'" @click="setStatus(s.key)">{{ s.label }}</button>
              </div>
              <select id="sp-urgent" v-model="urgent" class="form-control form-control-sm w-auto" aria-label="النوع" @change="reload()">
                <option value="all">كل الأنواع</option>
                <option value="urgent">العاجلة فقط</option>
                <option value="normal">العادية فقط</option>
              </select>
            </div>
            <input id="sp-q" v-model="q" type="search" class="form-control form-control-sm mt-75" placeholder="بحث: اسم المدرسة، الجوال، نص الرسالة، رقم التذكرة" @input="searchSoon()">
          </div>
          <div class="list">
            <div v-if="loading && !items.length" class="text-center text-muted p-2">جاري التحميل…</div>
            <div v-if="!loading && !items.length" class="text-center text-muted p-2">لا توجد تذاكر</div>
            <button v-for="t in items" :key="t._id" type="button" class="item" :class="{ active: current && current.ticket._id == t._id, unread: t.unread > 0 }" @click="open(t._id)">
              <div class="d-flex justify-content-between align-items-center">
                <strong class="school">{{ t.school_name || 'مدرسة' }}</strong>
                <small class="text-muted">{{ ago(t.last_at) }}</small>
              </div>
              <div class="title">{{ t.title }}</div>
              <div class="last text-muted">{{ t.last_from == 1 ? 'الدعم: ' : '' }}{{ t.last_text }}</div>
              <div class="d-flex flex-wrap align-items-center chips">
                <span v-if="t.urgent" class="badge badge-danger">عاجلة</span>
                <span v-if="t.urgent_blocked" class="badge badge-light-dark" title="المدرسة موقوفة عن التذاكر العاجلة">موقوف عن العاجل</span>
                <span v-if="t.status == 1" class="badge badge-light-secondary">مغلقة</span>
                <span v-if="t.waiting_min > 0" class="badge" :class="t.waiting_min >= 15 ? 'badge-light-danger' : 'badge-light-warning'">ينتظر {{ duration(t.waiting_min) }}</span>
                <span v-if="t.unread > 0" class="badge badge-pill badge-primary">{{ t.unread }} جديدة</span>
              </div>
            </button>
            <div v-if="hasMore" class="text-center p-1">
              <button class="btn btn-sm btn-outline-primary" :disabled="loading" @click="more()">تحميل المزيد</button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-7 g">
        <div class="card mb-0 chat-card">
          <div v-if="!current" class="card-body text-center text-muted empty">
            <i class="fa fa-comments-o fa-3x"></i>
            <p class="mt-1 mb-0">اختر تذكرة من القائمة</p>
          </div>
          <template v-else>
            <div class="card-body pb-75 chat-head">
              <div class="d-flex flex-wrap justify-content-between align-items-start">
                <div>
                  <h5 class="mb-25">
                    <span v-if="current.ticket.urgent" class="badge badge-danger">عاجلة</span>
                    {{ current.school.name }}
                  </h5>
                  <div class="text-muted small">
                    <bdi dir="ltr">{{ current.school.phone }}</bdi>
                    <a v-if="current.school.phone" :href="'https://wa.me/' + current.school.phone" target="_blank" rel="noopener" class="ml-50"><i class="fa fa-whatsapp"></i> واتساب</a>
                    <a v-if="current.school.phone" :href="'tel:+' + current.school.phone" class="ml-50"><i class="fa fa-phone"></i> اتصال</a>
                    <span v-if="current.school.city"> · {{ current.school.city }}</span>
                  </div>
                  <div class="text-muted small">
                    فتحها: {{ current.ticket.opened_by || '—' }}<span v-if="current.ticket.source"> · {{ current.ticket.source }}</span> · {{ current.ticket.date }}
                  </div>
                </div>
                <div class="d-flex flex-wrap head-actions">
                  <button v-if="current.ticket.status == 0" class="btn btn-sm btn-outline-danger" @click="setTicket(false)"><i class="fa fa-check"></i> إغلاق التذكرة</button>
                  <button v-else class="btn btn-sm btn-outline-primary" @click="setTicket(true)"><i class="fa fa-undo"></i> إعادة فتح</button>
                  <!-- stop / allow this school's urgent tickets (it can still open normal tickets) -->
                  <button v-if="current.school.urgent_blocked" class="btn btn-sm btn-outline-success" :disabled="blocking" @click="setUrgentBlock(false)"><i class="fa fa-play"></i> السماح بالتذاكر العاجلة</button>
                  <button v-else class="btn btn-sm btn-outline-dark" :disabled="blocking" @click="setUrgentBlock(true)"><i class="fa fa-pause"></i> إيقاف التذاكر العاجلة لهذه المدرسة</button>
                </div>
              </div>
              <div v-if="current.school.urgent_blocked" class="alert alert-secondary py-50 px-1 mt-50 mb-0 small">
                <i class="fa fa-pause-circle"></i> موقوفة عن التذاكر العاجلة<span v-if="current.school.urgent_block && current.school.urgent_block.by"> بواسطة {{ current.school.urgent_block.by }}</span><span v-if="current.school.urgent_block && current.school.urgent_block.reason"> — {{ current.school.urgent_block.reason }}</span>. تستطيع فتح تذاكر دعم عادية فقط.
              </div>
              <div class="d-flex flex-wrap chips mt-50">
                <span v-for="s in current.school.services" :key="s.service" class="badge" :class="s.valid ? 'badge-light-success' : 'badge-light-danger'" :title="'ينتهي ' + s.exdate">{{ s.title }} · {{ s.valid ? 'فعّال' : 'منتهي' }}</span>
              </div>
              <div class="title-line mt-50"><strong>المشكلة:</strong> {{ current.ticket.title }}</div>
            </div>
            <div ref="msgs" class="msgs">
              <div v-for="m in current.messages" :key="m._id" class="msg" :class="m.from == 1 ? 'support' : 'school'">
                <div class="who small">{{ m.from == 1 ? (m.by_name || 'الدعم') : (m.by_name || current.school.name) }}</div>
                <div v-if="m.message" class="text">{{ m.message }}</div>
                <a v-if="m.kind == 'image'" :href="m.file" target="_blank" rel="noopener"><img :src="m.file" :alt="m.file_name || 'صورة مرفقة'" class="img"></a>
                <audio v-if="m.kind == 'voice'" controls preload="none" :src="m.file" class="voice"></audio>
                <a v-if="m.kind == 'file'" :href="m.file" target="_blank" rel="noopener" class="file"><i class="fa fa-paperclip"></i> {{ m.file_name || 'ملف مرفق' }}</a>
                <div class="meta small">{{ m.date }}<span v-if="m.kind == 'voice' && m.duration"> · {{ m.duration }} ث</span><span v-if="m.from == 1"> · {{ m.seen ? 'تمت رؤيتها' : 'لم تُقرأ بعد' }}</span></div>
              </div>
            </div>
            <div v-if="current.ticket.status == 0" class="card-body pt-75 composer">
              <div v-if="file" class="d-flex align-items-center attached">
                <i class="fa" :class="file.kind == 'image' ? 'fa-image' : file.kind == 'voice' ? 'fa-microphone' : 'fa-paperclip'"></i>
                <span class="mx-50">{{ file.file_name }}</span>
                <button class="btn btn-sm btn-link text-danger p-0" @click="file = null">إزالة</button>
              </div>
              <textarea id="sp-msg" v-model="message" class="form-control" rows="2" placeholder="اكتب الرد… (Ctrl + Enter للإرسال)" @keydown.ctrl.enter="send()" @keydown.meta.enter="send()"></textarea>
              <div class="d-flex flex-wrap align-items-center justify-content-between mt-50 actions">
                <div class="d-flex align-items-center">
                  <label for="sp-agent" class="mb-0 small text-muted">اسمك في الرد</label>
                  <input id="sp-agent" v-model="agent" class="form-control form-control-sm agent" maxlength="40" @change="saveAgent()">
                </div>
                <div class="d-flex align-items-center">
                  <input id="sp-file" ref="file" type="file" class="d-none" accept=".png,.jpg,.jpeg,.webp,.pdf,.doc,.docx,.xls,.xlsx,.m4a,.mp3,.wav,.ogg,.webm,.aac" @change="upload()">
                  <button class="btn btn-sm btn-outline-secondary" :disabled="uploading" @click="$refs.file.click()"><i class="fa" :class="uploading ? 'fa-spinner fa-spin' : 'fa-paperclip'"></i> مرفق</button>
                  <button class="btn btn-sm btn-primary ml-50" :disabled="sending || uploading || (!message.trim() && !file)" @click="send()"><i class="fa fa-paper-plane"></i> إرسال</button>
                </div>
              </div>
            </div>
            <div v-else class="card-body pt-75 text-center text-muted small">التذكرة مغلقة{{ current.ticket.closed_by ? ' بواسطة ' + current.ticket.closed_by : '' }}</div>
          </template>
        </div>
      </div>
    </template>

    <!-- VIP app sign-in and devices -->
    <template v-if="tab == 'vip'">
      <div class="col-12 col-lg-5 g">
        <div class="card card-body mb-0">
          <h5>بيانات دخول تطبيق الدعم VIP</h5>
          <p class="text-muted small">حساب واحد يستخدمه فريق الدعم في التطبيق، ويكتب كل موظف اسمه عند الدخول ليظهر للمدرسة في الردود.</p>
          <div class="alert p-75" :class="vip.configured ? 'alert-success' : 'alert-warning'">
            {{ vip.configured ? 'مفعّل · اسم المستخدم: ' : 'لم يتم إعداد بيانات الدخول بعد، لن يستطيع أحد الدخول للتطبيق.' }}<bdi v-if="vip.configured" dir="ltr">{{ vip.username }}</bdi>
          </div>
          <div class="form-group">
            <label for="vip-user">اسم المستخدم</label>
            <input id="vip-user" v-model="vipForm.username" dir="ltr" class="form-control" autocomplete="off" placeholder="support">
          </div>
          <div class="form-group">
            <label for="vip-pass">كلمة المرور الجديدة (8 أحرف على الأقل)</label>
            <div class="input-group">
              <input id="vip-pass" v-model="vipForm.password" :type="showPass ? 'text' : 'password'" dir="ltr" class="form-control" autocomplete="new-password">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button" @click="showPass = !showPass">{{ showPass ? 'إخفاء' : 'إظهار' }}</button>
                <button class="btn btn-outline-secondary" type="button" @click="genPass()">توليد</button>
              </div>
            </div>
          </div>
          <button class="btn btn-primary" :disabled="savingVip" @click="saveVip()">حفظ بيانات الدخول</button>
          <small class="text-muted d-block mt-50">الحفظ يسجّل خروج كل الأجهزة المسجلة.</small>
        </div>
      </div>
      <div class="col-12 col-lg-7 g">
        <div class="card mb-0">
          <div class="card-body pb-0"><h5>الأجهزة المسجلة ({{ vip.devices.length }})</h5></div>
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead><tr><th>الموظف</th><th>الجهاز</th><th>الإشعارات</th><th>آخر نشاط</th><th></th></tr></thead>
              <tbody>
                <tr v-if="!vip.devices.length"><td colspan="5" class="text-center text-muted">لا توجد أجهزة</td></tr>
                <tr v-for="d in vip.devices" :key="d._id">
                  <td>{{ d.name }}</td>
                  <td>{{ d.platform == 'ios' ? 'آيفون' : d.platform == 'android' ? 'أندرويد' : '—' }}</td>
                  <td><span class="badge" :class="d.has_fcm ? 'badge-light-success' : 'badge-light-secondary'">{{ d.has_fcm ? 'مفعّلة' : 'غير مفعّلة' }}</span></td>
                  <td>{{ ago(d.at) }}</td>
                  <td><button class="btn btn-sm btn-outline-danger" @click="removeDevice(d)">تسجيل خروج</button></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    var agent = '';
    try { agent = localStorage.getItem('support_agent_name') || ''; } catch (e) {}
    return {
      jwt: localStorage.getItem('jwt'),
      tab: 'tickets',
      statuses: [{ key: 'open', label: 'المفتوحة' }, { key: 'closed', label: 'المغلقة' }, { key: 'all', label: 'الكل' }],
      status: 'open',
      urgent: 'all',
      q: '',
      page: 0,
      items: [],
      hasMore: false,
      counts: { open_urgent: 0, open: 0, closed_today: 0 },
      avg: null,
      loading: false,
      current: null,
      message: '',
      file: null,
      agent: agent || 'فريق الدعم',
      sending: false,
      blocking: false,
      uploading: false,
      vip: { configured: false, username: '', devices: [] },
      vipForm: { username: '', password: '' },
      showPass: false,
      savingVip: false,
      timer: null,
      searchTimer: null,
    };
  },
  computed: {
    avgText() {
      return this.avg == null ? '—' : this.duration(this.avg);
    },
  },
  created() {
    this.reload();
    this.loadStats();
    var g = this;
    this.timer = setInterval(function() {
      if (document.hidden) return;
      g.refresh();
    }, 15000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearTimeout(this.searchTimer);
  },
  methods: {
    post(path, body) {
      return $.post(api + '/admin/support' + path, Object.assign({ jwt: this.jwt }, body || {}));
    },
    ago(d) {
      if (!d) return '';
      var m = Math.max(0, Math.floor((Date.now() - new Date(d).getTime()) / 60000));
      return m < 1 ? 'الآن' : 'منذ ' + this.duration(m);
    },
    duration(m) {
      if (m < 60) return m + ' د';
      if (m < 60 * 24) return Math.floor(m / 60) + ' س' + (m % 60 ? ' ' + (m % 60) + ' د' : '');
      return Math.floor(m / 1440) + ' يوم';
    },
    setStatus(s) {
      this.status = s;
      this.reload();
    },
    searchSoon() {
      var g = this;
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(function() { g.reload(); }, 400);
    },
    reload() {
      this.page = 0;
      this.loadList(false);
    },
    more() {
      this.page++;
      this.loadList(true);
    },
    loadList(append, silent) {
      var g = this;
      if (!silent) g.loading = true;
      return g.post('/tickets', { status: g.status, urgent: g.urgent, q: g.q, page: g.page }).then(function(r) {
        g.loading = false;
        if (r.status != 100) return alert(r.response);
        g.items = append ? g.items.concat(r.response.items) : r.response.items;
        g.hasMore = r.response.has_more;
        g.counts = r.response.counts;
      }).fail(function() { g.loading = false; });
    },
    loadStats() {
      var g = this;
      g.post('/stats').then(function(r) {
        if (r.status == 100) g.avg = r.response.avg_first_reply_min_7d;
      });
    },
    refresh() {
      if (this.tab != 'tickets') return;
      // the first page only, so "load more" pages stay as they are until the next reload
      if (this.page == 0) this.loadList(false, true);
      if (this.current) this.open(this.current.ticket._id, true);
    },
    open(id, silent) {
      var g = this;
      g.post('/ticket', { id: id }).then(function(r) {
        if (r.status != 100) { if (!silent) alert(r.response); return; }
        var box = g.$refs.msgs;
        var atBottom = !box || box.scrollHeight - box.scrollTop - box.clientHeight < 60;
        var changed = !g.current || g.current.ticket._id != id || g.current.messages.length != r.response.messages.length;
        g.current = r.response;
        g.items.forEach(function(t) { if (t._id == id) t.unread = 0; });
        if (changed && atBottom) g.$nextTick(function() { if (g.$refs.msgs) g.$refs.msgs.scrollTop = g.$refs.msgs.scrollHeight; });
      });
    },
    saveAgent() {
      try { localStorage.setItem('support_agent_name', this.agent.trim()); } catch (e) {}
    },
    upload() {
      var g = this, f = g.$refs.file.files[0];
      if (!f) return;
      if (f.size > 15 * 1024 * 1024) { g.$refs.file.value = ''; return alert('حجم الملف أكبر من 15 ميجابايت'); }
      var fd = new FormData();
      fd.append('jwt', g.jwt);
      fd.append('file', f, f.name);
      g.uploading = true;
      $.ajax({ type: 'POST', url: api + '/admin/support/upload', data: fd, cache: false, contentType: false, processData: false, timeout: 120000 })
        .done(function(r) {
          if (r.status != 100) return alert(r.response);
          g.file = r.response;
        })
        .fail(function() { alert('تعذّر رفع الملف'); })
        .always(function() { g.uploading = false; g.$refs.file.value = ''; });
    },
    send() {
      var g = this;
      if (g.sending || (!g.message.trim() && !g.file)) return;
      g.sending = true;
      g.saveAgent();
      g.post('/ticket/send', {
        id: g.current.ticket._id,
        message: g.message,
        file: g.file ? g.file.url : '',
        kind: g.file ? g.file.kind : '',
        file_name: g.file ? g.file.file_name : '',
        by_name: g.agent,
      }).then(function(r) {
        g.sending = false;
        if (r.status != 100) return alert(r.response);
        g.message = '';
        g.file = null;
        g.open(g.current.ticket._id);
        g.loadList(false, true);
      }).fail(function() { g.sending = false; alert('تعذّر الإرسال'); });
    },
    setTicket(reopen) {
      var g = this;
      if (!reopen && !confirm('إغلاق التذكرة؟')) return;
      g.post(reopen ? '/ticket/reopen' : '/ticket/close', { id: g.current.ticket._id, by_name: g.agent }).then(function(r) {
        if (r.status != 100) return alert(r.response);
        g.open(g.current.ticket._id);
        g.loadList(false, true);
        g.loadStats();
      });
    },
    setUrgentBlock(blocked) {
      var g = this;
      var reason = '';
      if (blocked) {
        reason = prompt('إيقاف التذاكر العاجلة لهذه المدرسة؟ ستستطيع فتح تذاكر دعم عادية فقط.\nالسبب (اختياري):', '');
        if (reason === null) return;
      } else if (!confirm('السماح للمدرسة بفتح تذاكر عاجلة مرة أخرى؟')) {
        return;
      }
      g.blocking = true;
      g.post('/school/urgent-block', { school_id: g.current.school._id, blocked: blocked, reason: reason, by_name: g.agent }).then(function(r) {
        g.blocking = false;
        if (r.status != 100) return alert(r.response);
        g.open(g.current.ticket._id);
        g.loadList(false, true);
      }).fail(function() { g.blocking = false; alert('تعذّر الحفظ'); });
    },
    openVip() {
      this.tab = 'vip';
      this.loadVip();
    },
    loadVip() {
      var g = this;
      g.post('/vip').then(function(r) {
        if (r.status != 100) return alert(r.response);
        g.vip = r.response;
        if (!g.vipForm.username) g.vipForm.username = r.response.username;
      });
    },
    genPass() {
      var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789', out = '';
      var buf = new Uint32Array(12);
      window.crypto.getRandomValues(buf);
      for (var i = 0; i < buf.length; i++) out += chars[buf[i] % chars.length];
      this.vipForm.password = out;
      this.showPass = true;
    },
    saveVip() {
      var g = this;
      if (!confirm('حفظ بيانات الدخول الجديدة؟ سيتم تسجيل خروج كل الأجهزة.')) return;
      g.savingVip = true;
      g.post('/vip/credentials', g.vipForm).then(function(r) {
        g.savingVip = false;
        alert(r.response);
        if (r.status == 100) { g.vipForm.password = ''; g.loadVip(); }
      }).fail(function() { g.savingVip = false; });
    },
    removeDevice(d) {
      var g = this;
      if (!confirm('تسجيل خروج جهاز ' + d.name + '؟')) return;
      g.post('/vip/device/remove', { id: d._id }).then(function(r) {
        if (r.status != 100) return alert(r.response);
        g.loadVip();
      });
    },
  },
};
</script>

<style scoped>
.head-actions { gap: 6px; }
/* the panel's style.scss makes every .badge full width */
.badge { width: auto; border-radius: 6px; }
.sp-head { gap: 12px; }
.stats { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 10px; margin-top: 14px; }
.stat { border: 1px solid #ebe9f1; border-radius: 8px; padding: 10px 12px; display: flex; flex-direction: column; gap: 2px; }
.stat span { color: #6e6b7b; font-size: 12px; }
.stat b { font-size: 22px; line-height: 1.2; }
.stat.urgent { border-color: #f3c2c2; background: #fff6f6; }
.stat.urgent b { color: #ea5455; }
.num { font-variant-numeric: tabular-nums; }
.filters { gap: 8px; }
.list-card, .chat-card { height: calc(100vh - 290px); min-height: 520px; display: flex; flex-direction: column; }
.list-card > .card-body, .chat-head, .composer { flex: 0 0 auto; }
.list { overflow-y: auto; flex: 1; border-top: 1px solid #ebe9f1; }
.item { display: block; width: 100%; text-align: inherit; background: none; border: 0; border-bottom: 1px solid #f0eff4; padding: 10px 14px; }
.item:hover, .item:focus { background: #f8f8fb; outline: none; }
.item:focus-visible { box-shadow: inset 0 0 0 2px #7367f0; }
.item.active { background: #eeedfd; }
.item.unread .title { font-weight: 700; }
.item .school { font-size: 14px; }
.item .title { margin-top: 2px; color: #5e5873; }
.item .last { font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.chips { gap: 4px; margin-top: 4px; }
.empty { display: flex; flex-direction: column; align-items: center; justify-content: center; flex: 1 1 auto; }
.chat-head { border-bottom: 1px solid #ebe9f1; }
.title-line { font-size: 13px; }
.msgs { flex: 1; overflow-y: auto; padding: 14px; display: flex; flex-direction: column; gap: 10px; background: #fafafc; }
.msg { max-width: 78%; border-radius: 12px; padding: 8px 12px; display: flex; flex-direction: column; gap: 4px; }
.msg.school { align-self: flex-start; background: #fff; border: 1px solid #ebe9f1; }
.msg.support { align-self: flex-end; background: #7367f0; color: #fff; }
.msg.support .meta, .msg.support .who { color: rgba(255, 255, 255, 0.8); }
.msg.support a { color: #fff; text-decoration: underline; }
.msg .who { font-weight: 600; color: #6e6b7b; }
.msg .text { white-space: pre-wrap; word-break: break-word; }
.msg .meta { color: #a8a5b4; }
.msg .img { max-width: 240px; max-height: 240px; border-radius: 8px; display: block; }
.msg .voice { width: 240px; max-width: 100%; }
.composer { border-top: 1px solid #ebe9f1; }
.attached { font-size: 13px; margin-bottom: 6px; }
.actions { gap: 8px; }
.agent { width: 140px; margin-inline-start: 8px; }
@media (max-width: 991px) {
  .list-card { height: auto; min-height: 0; max-height: 60vh; }
  .chat-card { height: 80vh; }
  .stats { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .msg { max-width: 92%; }
}
</style>
